/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {createNgZone as ɵangular_packages_platform_browser_testing_testing_a} from './src/browser_util';